<template>
     <el-dialog
     :append-to-body="true"
     class="dataView"
      :visible.sync="data.dataVisible"
       :close-on-click-modal="false"
      width="35%">
      <span slot="title" class="">
        <span class="title">查看数据</span>
      </span>
      <el-row type="flex" >
        <el-select v-model="timeValue" @change="selChange" size="small" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        <el-date-picker
            v-show="showDate"
            size="small"
            v-model="dateTime"
            @change="dateChage"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
      </el-row>
      <div class="dataContent">
        <el-table
          border
          size="small"
          :data="dataList"
          tooltip-effect="dark"
          style="width: 100%">
          <template slot="empty">
            <emptyView style="margin:10px">
            </emptyView>
          </template>
          <el-table-column
            prop="createTime"
            label="云端接收时间">
          </el-table-column>
          <el-table-column
            prop="time"
            label="设备上报时间">
          </el-table-column>
          <el-table-column
            prop="value"
            label="原始值">
            <template slot-scope="scope">
                <!-- <template v-if="scope.row.value && scope.row.value.length">
                  <el-select size="mini" @change="selChange" v-model="structValue" placeholder="请查看">
                    <el-option
                      v-for="subItem in item.dataType.specs"
                      :key="subItem.identifier"
                      :label="subItem.name"
                      :value="subItem.identifier">
                    </el-option>
                  </el-select>
                </template> -->
                <template>
                  {{scope.row.value}}
                </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-row :span="24" type="flex" justify="end">
        <div class="showAll"> 共<span>{{pageParams.total}}</span>条数据</div>
        <el-pagination
          layout="prev, pager, next"
          @current-change="currentPageChange"
          :current-page="pageParams.pageNumber"
          :page-size="pageParams.pageSize"
          :pager-count="5"
          :total="pageParams.total">
        </el-pagination>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeView">关 闭</el-button>
      </span>
     </el-dialog>
</template>
<script>
import emptyView from '@/components/empty_view/empty'
import { historyProperties } from '@/api/deviceManagement'
import { dataFormat } from '@/utils/'
export default {
  components: {
    emptyView
  },
  props: {
    data: {
      type: Object
    },
    deviceDetail: {
      type: Object
    },
    propertyName: {
      type: String
    },
    type: {
      type: String
    }
  },
  data () {
    return {
      options: [{
        value: '1',
        label: '1小时'
      }, {
        value: '2',
        label: '24小时'
      }, {
        value: '3',
        label: '7天'
      }, {
        value: '4',
        label: '自定义'
      }],
      timeValue: '1',
      dateTime: '',
      showDate: false,
      dataList: [],
      // 时间这里按照时间戳来
      dateParams: {
        startTime: '',
        endTime: ''
      },
      // 时间分页
      pageParams: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    closeView () {
      console.log('closeView')
      this.$emit('close-data-view', 8888)
    },
    selChange (value) {
      value === '4'
        ? this.showDate = true
        : (
          this.showDate = false,
          // 初始起始时间
          this.getDate(value),
          this.getHistoryProperties()
        )
    },
    getDate (type) {
      // 用于获起始时间的时间戳,毫秒
      const dateParams = {
        beginTime: Date.parse(new Date()),
        endTime: Date.parse(new Date()),
        oneHourTiem: 60 * 60 * 1000,
        oneDayTime: 24 * 60 * 60 * 1000
      }
      this.dateParams.endTime = dateParams.endTime
      type === '1'// 小时
        ? this.dateParams.startTime = dateParams.beginTime - dateParams.oneHourTiem
        : type === '2'// 24小时
          ? this.dateParams.startTime = dateParams.beginTime - dateParams.oneDayTime
          : type === '3'// 7天
            ? this.dateParams.startTime = dateParams.beginTime - (dateParams.oneDayTime * 7)
            : ''
    },
    getHistoryProperties () {
      // 先固定，用作测试
      // const productKey = 'R589hUgZrO8'
      // const deviceName = 'ib95452X058c0mr72868'
      // const propertyName = 'LightLux'// 先固定用于测试
      const productKey = this.deviceDetail.productKey
      const deviceName = this.deviceDetail.deviceName
      const propertyName = this.propertyName// 先固定用于测试
      const params = Object.assign(
        {
          productKey: productKey,
          deviceName: deviceName,
          propertyName: propertyName
        },
        this.pageParams,
        this.dateParams
      )
      console.log('请求历史数据参数：', params)
      historyProperties(params).then(res => {
        res = res.data
        console.log('获取运行状态的历史数据：', res)
        const propertyName = this.propertyName// 先固定用于测试
        this.pageParams.total = res.data.recordCount
        this.dataList = res.data.list.map(item => {
          console.log('找到了对应item:', item.msg.params[propertyName])
          return { createTime: dataFormat(item.createTime), time: dataFormat(item.msg.timestamp), value: item.msg.params[propertyName] }
        })
        console.log('this.dataList.length:', this.dataList.length)
      })
    },
    currentPageChange (num) {
      this.pageParams.pageNumber = num
      this.getHistoryProperties()
    },
    dateChage () {
      this.pageParams.pageNumber = 1
      // console.log('日期变更：', this.dateTime)
      this.dateParams.startTime = Date.parse(this.dateTime[0])
      this.dateParams.endTime = Date.parse(this.dateTime[1])
      // 获取数据
      this.getHistoryProperties()
    }
  },
  watch: {
    // 监听窗口打开请求数据
    'data.dataVisible' () {
      console.log('deviceDetail:', this.deviceDetail)
      this.data.dataVisible
        ? (
          // 每次点开弹窗，初始化数据
          this.dateTime = [],
          this.timeValue = '1',
          this.showDate = false,
          this.pageParams.pageNumber = 1,
          this.getDate(this.timeValue),
          this.getHistoryProperties()
        )
        : ''
    }
  },
  created () {

  }
}
</script>
<style lang="less" scope>
 .dataView{
   .title{
     font-size: 16px;
   }
   .el-select{
     margin-right: 10px;
   }
   .dataContent{
     margin-top: 10px;
   }
   .showAll{
      display: flex;
      align-items: center;
      span{
        color: #f0bd95;
      }
    }
  }
</style>
